export const NOT_INITIALIZED = 'NotInitialized';
export const AUTHENTICATING = 'Authenticating';
export const AUTHENTICATED = 'Authenticated';
export const NOT_AUTHENTICATED = 'NotAuthenticated';
